export default "__VITE_ASSET__2qATnLgy__"